import { inject, Injectable, signal } from '@angular/core';
import { HomeContentService, IPromptPreset, IShortcut } from '../services/home-content.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HomeContentStore {
    private readonly _homeContentService = inject(HomeContentService);
    private readonly _prompts = signal<IPromptPreset[]>([]);
    private readonly _shortcuts = signal<IShortcut[]>([]);
    private readonly _loaded = signal(false);
    private readonly _loading = signal(false);
    private loadPromise: Promise<void> | null = null;

    public readonly prompts = this._prompts.asReadonly();
    public readonly shortcuts = this._shortcuts.asReadonly();
    public readonly loaded = this._loaded.asReadonly();

    public ensureLoaded(): Promise<void> {
        if (this._loaded()) {
            return Promise.resolve();
        }

        if (this.loadPromise) {
            return this.loadPromise;
        }

        this._loading.set(true);
        this.loadPromise = firstValueFrom(this._homeContentService.get())
            .then(content => {
                this._prompts.set(content.prompts ?? []);
                this._shortcuts.set(content.shortcuts ?? []);
                this._loaded.set(true);
            })
            .catch(error => {
                console.error('Failed to load home content', error);
                this._prompts.set([]);
                this._shortcuts.set([]);
            })
            .finally(() => {
                this._loading.set(false);
                this.loadPromise = null;
            });

        return this.loadPromise;
    }
}
